"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersSubmitMapHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const paper_1 = require("client/components/material/paper");
const router_1 = require("client/components/router");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/orders/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
const alert_1 = require("../../../../components/ui/alert");
const store_2 = require("../../../patients/store");
require("./orders-submit-map-header.less");
const auto_map_header_1 = require("./auto-map-header");
const moment = require("moment");
const ReactTooltip = require("react-tooltip");
let OrdersSubmitMapHeader = class OrdersSubmitMapHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.orderColumnsHeader = [];
        this.ordersToPersist = [];
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.invalidMapping = false;
        // @observable
        // public inquireAutomation: boolean = false;
        //B-038
        this.databaseColumnsHeader = [
            // #TK these headers reflect the headers from the database
            "PATIENT_FULL_NAME",
            "PATIENT_FIRST_NAME",
            "PATIENT_MIDDLE_NAME",
            "PATIENT_LAST_NAME",
            "PATIENT_DOB",
            "PATIENT_GENDER",
            "PATIENT_ADDRESS_1",
            "PATIENT_ADDRESS_2",
            "PATIENT_CITY",
            "PATIENT_STATE",
            "PATIENT_ZIP",
            "PATIENT_PHONE",
            "PATIENT_EMAIL",
            "PROVIDER_FULL_NAME",
            "PROVIDER_FIRST_NAME",
            "PROVIDER_LAST_NAME",
            "DATE",
            "DATE_TIME",
            "TIME",
            "PCN",
            "BIN_NUM",
            "PAYER_GROUP_ID",
            "INSURANCE_ID"
        ];
        this.mappedHeadersObject = {};
        this.mappedHeadersArray = [];
        this.importHeaders = null;
        this.siteId = null;
        this.automateImport = () => {
            const { mapChiroTouch, mapEclipse, mapVericle, mapNexgenHealthFusion, mapAdvancedMD, mapMeditouch, mapPracticeSuite, mapBillingVision, mapBillingPrecision, mapMedisoft, mapMacPractice } = new auto_map_header_1.AutoMapHeader(this.databaseColumnsHeader);
            if (store_1.ordersStore.fileFormat) {
                switch (store_1.ordersStore.fileFormat) {
                    case store_1.FileFormat.ChiroTouch:
                        mapChiroTouch();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.Eclipse:
                        mapEclipse();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.Vericle:
                        mapVericle();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.NexgenHealthFusion:
                        mapNexgenHealthFusion();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.AdvancedMD:
                        mapAdvancedMD();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.Meditouch:
                        mapMeditouch();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.PracticeSuite:
                        mapPracticeSuite();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.BillingVision:
                        mapBillingVision();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.BillingPrecision:
                        mapBillingPrecision();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.Medisoft:
                        mapMedisoft();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    case store_1.FileFormat.MacPractice:
                        mapMacPractice();
                        store_1.ordersStore.shouldAutomateSubmission && this.createHeaderObject();
                        break;
                    default:
                        this.mapIdenticalHeaders();
                        break;
                }
            }
            else {
                this.mapIdenticalHeaders();
            }
        };
        this.createHeaderObject = () => {
            const mappedHeaders = document.getElementsByClassName("mapping-container");
            // parse mapped header relationships from HTMLCollection
            [...mappedHeaders].forEach((mappedHeader) => {
                const importHeader = mappedHeader.querySelector(".import-header");
                if (importHeader && importHeader.dataset) {
                    const importKey = importHeader.dataset.headerName.trim();
                    const dbKey = mappedHeader.children[1].innerText
                        .replace(/(\r\n|\n|\r)/gm, "")
                        .trim();
                    this.mappedHeadersObject[dbKey] = importKey;
                }
            });
            store_1.ordersStore.mappedHeadersObject = this.mappedHeadersObject;
            store_1.ordersStore.submitAutomation = true;
            router_1.RouteManager.transitionTo("/claims/submit/preview");
        };
        this.formulateOrderToPersist = () => {
            const importedOrders = store_1.ordersStore.importedOrders;
            this.ordersToPersist = importedOrders.map((order) => {
                const newOrder = {};
                // @tkay
                store_1.ordersStore.dbHeaders.forEach(key => {
                    newOrder[key] = this.mappedHeadersObject[key]
                        ? order[this.mappedHeadersObject[key]]
                        : "";
                });
                return newOrder;
            });
            // console.log("this.ordersToPersist is", this.ordersToPersist);
            // @tkay logic to set first and last names if full name was provided.
            this.ordersToPersist = store_1.ordersStore
                .fillInMissingData(this.ordersToPersist)
                .filter((order) => {
                const firstName = order.PATIENT_FIRST_NAME;
                const lastName = order.PATIENT_LAST_NAME;
                return firstName && lastName;
            });
        };
        this.handleOnDragEnd = (event) => {
            event.target.classList.toggle("drag-accent");
            // change opacity back to 1 on drag end
            event.target.style.opacity = "1";
        };
        this.handleOnDragStart = (event) => {
            event.dataTransfer.setData("text", event.target.innerText);
            event.dataTransfer.setData("elementId", event.target.id);
            event.dataTransfer.setData("elementParentId", event.target.parentElement.id);
            event.target.classList.toggle("drag-accent");
            event.target.parentNode.classList.remove("drag-over-accent"); // #TK remove accent class from drop zone.
            // change opacity on drag start
            event.target.style.opacity = "0.4";
        };
        this.handleOnDrop = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const child = document.getElementById(event.dataTransfer.getData("elementId"));
            // #TK add triangle tooltip on link
            if (event.target.classList.contains("droppable")) {
                event.target.appendChild(child);
            }
            else {
                const oldElement = event.target;
                const newElement = document.getElementById(event.dataTransfer.getData("elementId"));
                const dropArea = event.target.parentElement;
                const newElementOldParent = document.getElementById(event.dataTransfer.getData("elementParentId"));
                dropArea.removeChild(oldElement);
                dropArea.appendChild(newElement);
                newElementOldParent.appendChild(oldElement);
            }
            this.renderAccentToolTip();
            return false;
        };
        this.renderAccentToolTip = () => {
            const importMapArea = document.getElementsByClassName("mapping-container__drop-area");
            try {
                [...importMapArea].forEach(area => {
                    if (area && area.children) {
                        const children = [...area.children];
                        if (children) {
                            children.forEach(child => child.classList.add("link-accent"));
                        }
                    }
                });
                const importHeaderContainer = document.getElementById("import-header-container");
                if (importHeaderContainer && importHeaderContainer.children) {
                    [...importHeaderContainer.children].forEach(child => child.classList.remove("link-accent"));
                }
            }
            catch (e) {
                console.log("error on renderaccenttooltip", e);
            }
        };
        this.handleOnDragEnter = (event) => false;
        this.handleOnDragOver = (event) => {
            event.preventDefault();
            if (event.target.classList.contains("mapping-container__drop-area")) {
                event.target.classList.add("drag-over-accent");
            }
            return false;
        };
        this.handleOnDragExit = (event) => {
            // event.preventDefault();
        };
        this.handleOnDragLeave = (event) => {
            if (event.target.classList.contains("mapping-container__drop-area")) {
                event.target.classList.remove("drag-over-accent");
            }
            return false;
        };
        this.handleOnPreview = () => {
            const mappedHeaders = document.getElementsByClassName("mapping-container");
            // parse mapped header relationships from HTMLCollection
            [...mappedHeaders].forEach((mappedHeader) => {
                const importHeader = mappedHeader.querySelector(".import-header");
                if (importHeader && importHeader.dataset) {
                    const importKey = importHeader.dataset.headerName.trim();
                    const dbKey = mappedHeader.children[1].innerText
                        .replace(/(\r\n|\n|\r)/gm, "")
                        .trim();
                    this.mappedHeadersObject[dbKey] = importKey;
                }
            });
            store_1.ordersStore.mappedHeadersObject = this.mappedHeadersObject;
            router_1.RouteManager.transitionTo("/claims/submit/preview");
        };
        this.handleOnCancel = () => {
            // console.log('handleOnCancel triggered');
        };
        this.checkValidMapping = () => {
            for (const header in this.mappedHeadersObject) {
                if (this.mappedHeadersObject[header] === "") {
                    this.invalidMapping = true;
                }
            }
        };
        this.renderImportHeaders = () => this.orderColumnsHeader.map((dataColumn, i) => (React.createElement(React.Fragment, { key: i },
            React.createElement(ReactTooltip, { delayShow: 100 }),
            React.createElement("div", { style: { whiteSpace: "pre" }, "data-tip": store_1.ordersStore.sampleFirstDataRow
                    ? store_1.ordersStore.sampleFirstDataRow[i] || ""
                    : "", className: "import-header", "data-header-name": dataColumn, id: `draggable-import-header-${i}`, draggable: true, onDragStart: this.handleOnDragStart, onDragEnd: this.handleOnDragEnd }, dataColumn))));
        this.renderDatabaseHeaders = () => this.databaseColumnsHeader.map((dataColumn, i) => (React.createElement("div", { className: "mapping-container", key: i },
            React.createElement("div", { id: `mapping-container__drop-area-${i}`, "data-name": dataColumn, className: "mapping-container__drop-area droppable", onDragEnter: this.handleOnDragEnter, onDragLeave: this.handleOnDragLeave, onDragOver: this.handleOnDragOver, onDragExit: this.handleOnDragExit, onDrop: this.handleOnDrop }),
            React.createElement("div", { className: "mapping-container__database-header--order" }, dataColumn))));
        this.isDateTime = (headerTextParsed) => {
            const dateHeaderFound = this.orderColumnsHeader.find((col) => typeof col === "string" && col.toLowerCase().trim() === headerTextParsed);
            let dateIndex = -1;
            if (dateHeaderFound) {
                dateIndex = this.orderColumnsHeader.indexOf(dateHeaderFound);
            }
            if (dateIndex > -1) {
                return (store_1.ordersStore.sampleFirst5DataRows.length &&
                    store_1.ordersStore.sampleFirst5DataRows.some((sampleRow) => {
                        const date = sampleRow[dateIndex];
                        const format = ["M/D/YYYY h:m A", "M/D/YY h:m A"];
                        return moment(date, format, true).isValid();
                    }));
            }
            return false;
        };
        this.mapIdenticalHeaders = () => {
            const databaseHeaderPaper = document.getElementById("database-header-paper");
            const importHeaders = document.getElementsByClassName("import-header");
            // new way to check for similar headers to automate the mapping based on a guess.
            const databaseColumnsHeaderParsed = this.databaseColumnsHeader.map(header => header.replace(/\s+/g, "").toLowerCase());
            // B-038 claims latest // B-038.7 for claims luv solution 10/07/2024 add patient firstname
            [...importHeaders].forEach((header) => {
                header.innerText = header.innerText.toLowerCase();
                if (header.innerText === "patient first name" ||
                    header.innerText === "firstname" ||
                    header.innerText === "pat f name" ||
                    header.innerText === "first name" ||
                    header.innerText === "patient firstname") {
                    header.innerText = "PATIENT_FIRST_NAME";
                }
                if (header.innerText === "pat m mame" ||
                    header.innerText === "patient middle name" ||
                    header.innerText === "middlename" ||
                    header.innerText === "middle name") {
                    header.innerText = "PATIENT_MIDDLE_NAME";
                }
                if (header.innerText === "pat l name" ||
                    header.innerText === "patient last name" ||
                    header.innerText === "last name" ||
                    header.innerText === "lastname" ||
                    header.innerText === "patient lastname") {
                    header.innerText = "PATIENT_LAST_NAME";
                }
                if (header.innerText === "full name" ||
                    header.innerText === "patient full name") {
                    header.innerText = "PATIENT_FULL_NAME";
                }
                if (header.innerText === "patient address line 1" ||
                    header.innerText === "patient address line1" ||
                    header.innerText === "patient address" ||
                    header.innerText === "street address" ||
                    header.innerText === "street address 1" ||
                    header.innerText === "street address1" ||
                    header.innerText === "patient address 1" ||
                    header.innerText === "patient_address_1" ||
                    header.innerText === "patient address1" ||
                    header.innerText === "address 1" ||
                    header.innerText === "address1" ||
                    header.innerText === "pat address 1" ||
                    header.innerText === "pat address1" ||
                    header.innerText === "address") {
                    header.innerText = "PATIENT_ADDRESS_1";
                }
                if (header.innerText === "patient address line 2" ||
                    header.innerText === "patient address line2" ||
                    header.innerText === "Patient address 2" ||
                    header.innerText === "Patient address2" ||
                    header.innerText === "patient_address_2" ||
                    header.innerText === "street address 2" ||
                    header.innerText === "street address2" ||
                    header.innerText === "pat address 2" ||
                    header.innerText === "pat address2" ||
                    header.innerText === "address2" ||
                    header.innerText === "address 2") {
                    header.innerText = "PATIENT_ADDRESS_2";
                }
                if (header.innerText === "patient city" ||
                    header.innerText === "patient address city" ||
                    header.innerText === "city" ||
                    header.innerText === "pat city") {
                    header.innerText = "PATIENT_CITY";
                }
                if (header.innerText === "pat zip" ||
                    header.innerText === "patient zip" ||
                    header.innerText === "postal" ||
                    header.innerText === "postal code" ||
                    header.innerText === "patient address zip code" ||
                    header.innerText === "pat zip5" ||
                    header.innerText === "patient address zip" ||
                    header.innerText === "address zip" ||
                    header.innerText === "zip" ||
                    header.innerText === "patient zip code" ||
                    header.innerText === "zip code") {
                    header.innerText = "PATIENT_ZIP";
                }
                if (header.innerText === "home phone" ||
                    header.innerText === "homephone" ||
                    header.innerText === "cell phone" ||
                    header.innerText === "patient phone" ||
                    header.innerText === "phone" ||
                    header.innerText === "mobile" ||
                    header.innerText === "patient preferred phone" ||
                    header.innerText === "patienthomephone") {
                    header.innerText = "PATIENT_PHONE";
                }
                if (header.innerText === "patient email" ||
                    header.innerText === "pat email" ||
                    header.innerText === "email") {
                    header.innerText = "PATIENT_EMAIL";
                }
                if (header.innerText === "date time" ||
                    header.innerText === "appointment date appointment time" ||
                    header.innerText === "date and time") {
                    header.innerText = "DATE_TIME";
                }
                if (header.innerText === "state" ||
                    header.innerText === "patient address state" ||
                    header.innerText === "patient state" ||
                    header.innerText === "pat state" ||
                    header.innerText === "province") {
                    header.innerText = "PATIENT_STATE";
                }
                if (header.innerText === "appointment date" ||
                    header.innerText === "date") {
                    header.innerText = "DATE";
                }
                if (header.innerText === "appointment time" ||
                    header.innerText === "time") {
                    header.innerText = "TIME";
                }
                if (header.innerText === "pat sex" ||
                    header.innerText === "sex" ||
                    header.innerText === "patient gender" ||
                    header.innerText === "gender") {
                    header.innerText = "PATIENT_GENDER";
                }
                if (header.innerText === "pat birthdate" ||
                    header.innerText === "pat birthday" ||
                    header.innerText === "birthday" ||
                    header.innerText === "birth date" ||
                    header.innerText === "dob" ||
                    header.innerText === "date of birth" ||
                    header.innerText === "patient dob" ||
                    header.innerText === "birthdate") {
                    header.innerText = "PATIENT_DOB";
                }
                const headerText = header.innerText;
                const headerTextParsed = header.innerText
                    .replace(/\s+/g, "")
                    .toLowerCase();
                if (databaseColumnsHeaderParsed.includes(headerTextParsed)) {
                    let index = -1;
                    if (headerTextParsed === "date") {
                        if (this.isDateTime(headerTextParsed)) {
                            index = databaseColumnsHeaderParsed.indexOf("date_time");
                        }
                        else {
                            index = databaseColumnsHeaderParsed.indexOf(headerTextParsed);
                        }
                    }
                    else {
                        index = databaseColumnsHeaderParsed.indexOf(headerTextParsed);
                    }
                    const dropArea = databaseHeaderPaper.querySelector(`[data-name=${this.databaseColumnsHeader[index]}]`);
                    if (dropArea) {
                        if (!dropArea.hasChildNodes()) {
                            dropArea.appendChild(header);
                        }
                    }
                }
                else {
                    console.log("Does not include", headerText);
                }
            });
            this.renderAccentToolTip();
        };
        // handle a redirect if no siteId selected -- make it so user cannot navigate to page.
        this.handleAuthRedirect = () => {
            if (!this.siteId) {
                router_1.RouteManager.transitionTo("/claims");
            }
        };
    }
    componentWillMount() {
        // const parsedRows = ordersStore.parsedRows[0]
        //   ? ordersStore.parsedRows[0].length
        //     ? ordersStore.parsedRows[0].filter(
        //         (row: string[]) => !row.every((cell: string) => !cell)
        //       )
        //     : []
        //   : [];
        // console.log("parsedRows is ", parsedRows);
        if (store_1.ordersStore.importColumnsHeader &&
            store_1.ordersStore.importColumnsHeader.length) {
            this.orderColumnsHeader = store_1.ordersStore.importColumnsHeader.map(header => header.trim());
        }
        else {
            this.orderColumnsHeader = [];
            router_1.RouteManager.transitionTo("/claims/submit");
        }
        this.databaseColumnsHeader.forEach(header => (this.mappedHeadersObject[header] = ""));
        store_2.patientsStore.databaseColumnsHeader = this.databaseColumnsHeader;
    }
    componentDidMount() {
        store_1.ordersStore.dbHeaders = this.databaseColumnsHeader;
        this.automateImport();
    }
    render() {
        {
            this.orderColumnsHeader.length && this.mapIdenticalHeaders();
        }
        return (React.createElement("div", { className: "orders-submit-map" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Header Map", subLabel: "" })),
            React.createElement(paper_1.MaterialPaper, { className: "orders-submit-map__header-preview" },
                this.invalidMapping && (React.createElement(alert_1.UiAlert, { type: "warning", message: "Some of the mapping fields are missing", dismissable: true, onRequestDismiss: () => (this.invalidMapping = false) })),
                React.createElement("div", { className: "header-paper__message" },
                    React.createElement("h3", null, "Please map the headers"),
                    React.createElement("div", null,
                        React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/claims/submit/select" }, "Back"),
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnPreview }, "Preview"))),
                React.createElement("div", { className: "header-paper__container" },
                    React.createElement("div", { className: "header-paper__import--order" },
                        React.createElement("div", { id: "import-header-container", className: "import-header-container droppable", onDragOver: this.handleOnDragOver, onDrop: this.handleOnDrop }, this.renderImportHeaders())),
                    React.createElement("div", { id: "database-header-paper", className: "header-paper__database" },
                        React.createElement("div", { className: "database-header-container" }, this.renderDatabaseHeaders())))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" }))));
    }
};
__decorate([
    mobx_1.observable
], OrdersSubmitMapHeader.prototype, "orderColumnsHeader", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitMapHeader.prototype, "ordersToPersist", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitMapHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitMapHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmitMapHeader.prototype, "invalidMapping", void 0);
OrdersSubmitMapHeader = __decorate([
    mobx_react_1.observer
], OrdersSubmitMapHeader);
exports.OrdersSubmitMapHeader = OrdersSubmitMapHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-submit-map-header/orders-submit-map-header.tsx
// module id = 3784
// module chunks = 0